export default __webpack_public_path__ + "static/game-intro-02-0ea5adec772adf403adb371a1214fe45.png";